import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title max-sm-w-100" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  class: "d-flex justify-content-end gap-3",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary max-sm-text-nowrap",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_sales_order_filter_drown"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-light-primary max-sm-text-nowrap",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = { class: "me-0" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_16 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_17 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_18 = { class: "menu-item px-3" }
const _hoisted_19 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_21 = { class: "menu-link px-3" }
const _hoisted_22 = { class: "menu-item px-3" }
const _hoisted_23 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_25 = { class: "menu-item px-3" }
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_27 = { class: "menu-item px-3" }
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_29 = { class: "menu-item px-3" }
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_31 = { class: "menu-item px-3 mb-3" }
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_33 = { class: "card-body pt-0 vip-table" }
const _hoisted_34 = { class: "fs-7 text-gray-400" }
const _hoisted_35 = { class: "mw-100px overflow-hidden" }
const _hoisted_36 = { class: "text-truncate fs-7 text-gray-400" }
const _hoisted_37 = { class: "fs-7 text-gray-400" }
const _hoisted_38 = { class: "mw-100px overflow-hidden" }
const _hoisted_39 = { class: "text-truncate fs-7 text-gray-400" }
const _hoisted_40 = { class: "fs-7 text-gray-400" }
const _hoisted_41 = { class: "mw-100px overflow-hidden" }
const _hoisted_42 = { class: "text-truncate" }
const _hoisted_43 = { class: "text-truncate fs-7 text-gray-400" }
const _hoisted_44 = { class: "fs-7 text-gray-400" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "mw-100px overflow-hidden" }
const _hoisted_47 = { class: "text-truncate" }
const _hoisted_48 = { class: "text-truncate fs-7 text-gray-400" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "d-flex gap-2" }
const _hoisted_51 = ["title"]
const _hoisted_52 = ["title"]
const _hoisted_53 = ["title"]
const _hoisted_54 = ["title"]
const _hoisted_55 = {
  key: 1,
  class: "badge badge-light-warning text-uppercase"
}
const _hoisted_56 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_productDefaultTable = _resolveComponent("productDefaultTable")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
            class: "form-control form-control-solid w-250px ps-14 max-sm-w-100",
            placeholder: _ctx.t('common.search')
          }, null, 40, _hoisted_6), [
            [_vModelText, _ctx.search]
          ]),
          _withDirectives(_createElementVNode("span", {
            class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
            style: {"cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
          }, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
          ], 512), [
            [_vShow, _ctx.search != '']
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.options.additionalService_value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.options.additionalService_value) = $event)),
              clearable: "",
              onChange: _ctx.storeChange,
              placeholder: _ctx.t('salesOrder.additionalService')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.additionalService, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "placeholder"])
          ]),
          _createVNode(_component_window_resize, null, {
            sm: _withCtx(() => [
              _createElementVNode("button", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
              ])
            ]),
            lg: _withCtx(() => [
              _createElementVNode("button", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_FilterDropdown, {
            ref: "filterDropdownRef",
            showType: 2,
            statusValue: _ctx.options.status_value,
            onSubmitFilter: _ctx.handleFilter,
            onResetFilter: _ctx.handleFilterReset
          }, null, 8, ["statusValue", "onSubmitFilter", "onResetFilter"]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-icon btn-bg-light btn-active-color-primary",
              "data-kt-menu-trigger": "click",
              "data-kt-menu-placement": "bottom-end",
              "data-kt-menu-flip": "top-end",
              disabled: 
                _ctx.disabledExportSalesOrderItemList ||
                _ctx.disabledExportSalesFinancial ||
                _ctx.loading ||
                _ctx.disabledExportSalesProfilling ||
                _ctx.disabledExportOrderCombination ||
                _ctx.disabledExport ||
                _ctx.disabledExportSku
              
            }, [
              (
                  _ctx.disabledExportSalesOrderItemList ||
                  _ctx.disabledExportSalesProfilling ||
                  _ctx.disabledExportOrderCombination ||
                  _ctx.disabledExportSalesFinancial ||
                  _ctx.disabledExport ||
                  _ctx.disabledExportSku
                )
                ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                : (_openBlock(), _createElementBlock("i", _hoisted_16))
            ], 8, _hoisted_14),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_permission_common, { role: { auth: ['import'] } }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t("common.import")), 1)
                  ]),
                  _hoisted_20,
                  _createVNode(_component_router_link, {
                    to: '/sales-order/order-verification/import',
                    class: "menu-item px-3",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("salesOrder.importOrders")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t("common.export")), 1)
                  ]),
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.disabledExportOrderCombination || _ctx.loading,
                    }]),
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileExportOrderCombination && _ctx.fileExportOrderCombination(...args))),
                      style: {"font-size":"normal"}
                    }, [
                      (_ctx.disabledExportOrderCombination && !_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrder.exportOrderCombination")), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.disabledExportSalesOrderItemList || _ctx.loading,
                    }]),
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fileExportSalesOrderItemList && _ctx.fileExportSalesOrderItemList(...args))),
                      style: {"font-size":"normal"}
                    }, [
                      (_ctx.disabledExportSalesOrderItemList && !_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrder.exportSalesDetails")), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.disabledExport || _ctx.loading,
                    }]),
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fileExport && _ctx.fileExport(...args))),
                      style: {"font-size":"normal"}
                    }, [
                      (_ctx.disabledExport && !_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrder.export")), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.disabledExportSku || _ctx.loading,
                    }]),
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.fileExportSku && _ctx.fileExportSku(...args))),
                      style: {"font-size":"normal"}
                    }, [
                      (_ctx.disabledExportSku && !_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrder.exportSku")), 1)
                    ], 2)
                  ])
                ]),
                _: 1
              })
            ])
          ])), [
            [_directive_auth, { auth: ['import', 'export'] }]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_MBDatatablePlus, {
        class: "max-sm-text-nowrap",
        loading: _ctx.loading,
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "rows-per-page": _ctx.pageSize,
        onCurrentChange: _ctx.onCurrentPageChange,
        onItemsPerPageChange: _ctx.onRowsPerPageChange,
        onSort: _ctx.onColumnSort
      }, {
        "cell-sub": _withCtx(({ row: item }) => [
          (_openBlock(), _createBlock(_component_productDefaultTable, {
            key: item.id,
            isExpand: item.isExpand,
            order_id: item.id
          }, null, 8, ["isExpand", "order_id"]))
        ]),
        "cell-order_number": _withCtx(({ row: item }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: 
                    '/sales-order/order-verification/' + item.id + '/overview'
                  ,
                  class: "text-gray-800 text-hover-primary mb-1",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.order_number), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", _hoisted_34, _toDisplayString(item.relation_distribution.external_order_number), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.encrypt_order_number) + " ", 1)
            ]),
            _: 2
          }, 1024)
        ]),
        "cell-order_date": _withCtx(({ row: item }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(item.order_date)), 1),
                _createElementVNode("div", _hoisted_36, _toDisplayString(item.relation_distribution.__show.sales_manager
                      ? item.relation_distribution.__show.sales_manager
                      : _ctx.t("salesOrderOverview.byCustomer")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.order_date, "YYYY-MM-DD HH:mm")) + " ", 1)
            ]),
            _: 2
          }, 1024)
        ]),
        "cell-is_priority": _withCtx(({ row: item }) => [
          (item.relation_priority_management.priority_level)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["svg-icon svg-icon-2", 
              _ctx.getSalesOrderPriorityLevelSvgStyleMap(
                item.relation_priority_management.priority_level
              )
            ])
              }, [
                _createVNode(_component_inline_svg_icon, {
                  src: 
                _ctx.getSalesOrderPriorityLevelMap(
                  item.relation_priority_management.priority_level
                )
              
                }, null, 8, ["src"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        "cell-delivery_date": _withCtx(({ row: item }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(
                      item.relation_priority_management
                        .prioritised_close_date ??
                        item.relation_priority_management.standard_delivery_date
                    )), 1),
                _createElementVNode("div", _hoisted_39, _toDisplayString(item.relation_fulfillment.__show.mb_fulfillment_type), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(
                    item.relation_priority_management.prioritised_close_date ??
                      item.relation_priority_management.standard_delivery_date
                  )), 1),
                _createElementVNode("div", _hoisted_37, _toDisplayString(item.relation_fulfillment.__show.mb_fulfillment_type), 1)
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        "cell-customer": _withCtx(({ row: item }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(item.customer_lastname + item.customer_firstname), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(item.relation_distribution.__show.distribution_channel), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(item.customer_lastname + item.customer_firstname), 1),
                _createElementVNode("div", _hoisted_40, _toDisplayString(item.relation_distribution.__show.distribution_channel), 1)
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        "cell-articles": _withCtx(({ row: item }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.CommonArrayToString(item.brand)), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", null, _toDisplayString(item.relation_distribution.__show.distribution_model), 1),
                  (item.relation_distribution.__show.distribution_model)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, ","))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(item.relation_pim.__show.mb_order_type), 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.CommonArrayToString(item.brand)), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", null, _toDisplayString(item.relation_distribution.__show.distribution_model), 1),
                  (item.relation_distribution.__show.distribution_model)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, ","))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(item.relation_pim.__show.mb_order_type), 1)
                ])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        "cell-ordered_qty": _withCtx(({ row: item }) => [
          _createTextVNode(_toDisplayString(item.ordered_qty), 1)
        ]),
        "cell-grand_total_base": _withCtx(({ row: item }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover",
            disabled: 
              Number(item.base_total_paid) > 0 || !item.date_of_arrival
            
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: _normalizeClass({
                    'text-info': Number(item.base_total_paid) == 0,
                  })
                }, _toDisplayString(item.base_currency_code == "￥"
                      ? _ctx.$currency.currency(
                          item.grand_total_base,
                          2,
                          ".",
                          "",
                          item.base_currency_code + " "
                        )
                      : _ctx.$currency.currency(
                          item.grand_total_base,
                          2,
                          ",",
                          ".",
                          item.base_currency_code + " "
                        )), 3)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.plsPaymentInfo", [
                _ctx.formatDate(item.date_of_arrival, "YYYY.MM.DD"),
              ])) + " ", 1)
            ]),
            _: 2
          }, 1032, ["disabled"])
        ]),
        "cell-service": _withCtx(({ row: item }) => [
          _createElementVNode("div", _hoisted_50, [
            (
                item.relation_priority_management.high_priority_order ===
                _ctx.CommonSwtich.Active
              )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["svg-icon svg-icon-2", {
                'svg-icon-warning':
                  item.relation_priority_management.verified_status === 0,
                'svg-icon-success':
                  item.relation_priority_management.verified_status === 1,
              }]),
                  title: _ctx.t('salesOrder.priorityManagement')
                }, [
                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/distribution.svg" })
                ], 10, _hoisted_51))
              : _createCommentVNode("", true),
            (
                item.relation_pim.additional_pim_service === _ctx.CommonSwtich.Active
              )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["svg-icon svg-icon-2", {
                'svg-icon-warning': item.relation_pim.verified_status === 0,
                'svg-icon-success': item.relation_pim.verified_status === 1,
              }]),
                  title: _ctx.t('salesOrder.pimAdditionalService')
                }, [
                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/pim.svg" })
                ], 10, _hoisted_52))
              : _createCommentVNode("", true),
            (
                item.relation_fulfillment.additional_fulfillment_service ===
                _ctx.CommonSwtich.Active
              )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: _normalizeClass(["svg-icon svg-icon-2", {
                'svg-icon-warning':
                  item.relation_fulfillment.verified_status === 0,
                'svg-icon-success':
                  item.relation_fulfillment.verified_status === 1,
              }]),
                  title: _ctx.t('salesOrder.fulfillmentAdditionalService')
                }, [
                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/fulfillment.svg" })
                ], 10, _hoisted_53))
              : _createCommentVNode("", true),
            (
                item.relation_settlement.offline_payment_controlling ===
                _ctx.CommonRequiredSwtich.Requried
              )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 3,
                  class: _normalizeClass(["svg-icon svg-icon-2", {
                'svg-icon-warning':
                  item.relation_settlement.verified_status === 0,
                'svg-icon-success':
                  item.relation_settlement.verified_status === 1,
              }]),
                  title: _ctx.t('salesOrder.settlementAdditionalService')
                }, [
                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/settlement.svg" })
                ], 10, _hoisted_54))
              : _createCommentVNode("", true)
          ])
        ]),
        "cell-order_status": _withCtx(({ row: item }) => [
          (item.status === _ctx.SalesOrderNewStatus.Verified)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["badge text-uppercase", _ctx.orderStatus(item.status)])
              }, _toDisplayString(item.__show.status), 3))
            : (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.t("salesOrderOverview.pendingApproval")), 1))
        ]),
        "cell-actions": _withCtx(({ row: item }) => [
          _createVNode(_component_router_link, {
            to: 
              '/sales-order/order-verification/' + item.id + '/sales-profilling'
            ,
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
            onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_56, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
    ])
  ]))
}